import { cva } from 'class-variance-authority';
import React from 'react';
import { cn } from '../../lib/cn';

const badgeVariants = cva(
  'flex items-center whitespace-nowrap gap-1.5 rounded-sm px-2 py-0.5 text-[0.7rem] font-medium transition-colors',
  {
    variants: {
      variant: {
        default: 'bg-surface text-foreground rounded-md',
        secondary: 'bg-surface text-surface-foreground rounded-full',
        surface: 'bg-primary text-primary-foreground rounded-full',
        primary: 'bg-primary text-primary-foreground',
        destructive: 'bg-destructive text-destructive-foreground',
        outline: 'border border-input bg-background text-foreground',
      },
      size: {
        sm: 'px-2 h-5 text-xs',
        md: 'px-2 h-6 text-xs font-mono text-[11px] tracking-[0.02em] font-[350]',
        lg: 'px-3 h-7 text-xs',
      },
    },
    defaultVariants: {
      variant: 'default',
      size: 'md',
    },
  }
);

function Badge({ className, variant, size, ...props }) {
  return <div className={cn(badgeVariants({ variant, size }), className)} {...props} />;
}

export { Badge, badgeVariants };
